import { DocumentValidationCheck } from 'generated-graphql/types';

export const DOCUMENT_VALIDATION_LABELS: Record<
  DocumentValidationCheck,
  string
> = {
  [DocumentValidationCheck.CheckDocumentCornerInclusion]:
    'All corners are visible',
  [DocumentValidationCheck.CheckNameMatch]: "Owner's name matches",
  [DocumentValidationCheck.CheckExpirationDate]: 'Document has not expired',
  [DocumentValidationCheck.CheckIssueDate]: 'Document was issued in the last',
  [DocumentValidationCheck.CheckDateOfBirthInclusion]:
    'Date of birth is included',
  [DocumentValidationCheck.CheckHomeAddressInclusion]:
    'Home address is included'
};

/** Checks rendered as top-level checkboxes on the drawer, in display order. */
export const PRIMARY_VALIDATION_CHECKS: readonly DocumentValidationCheck[] = [
  DocumentValidationCheck.CheckDocumentCornerInclusion,
  DocumentValidationCheck.CheckNameMatch,
  DocumentValidationCheck.CheckExpirationDate
] as const;

export type DateRangeUnit = 'DAYS' | 'MONTHS' | 'YEARS';

export const DATE_RANGE_UNIT_OPTIONS: {
  label: string;
  value: DateRangeUnit;
}[] = [
  { label: 'Day(s)', value: 'DAYS' },
  { label: 'Month(s)', value: 'MONTHS' },
  { label: 'Year(s)', value: 'YEARS' }
];

export const DEFAULT_DATE_RANGE = { value: 3, unit: 'MONTHS' as DateRangeUnit };

/**
 * Ordered pool of "must contain" suggestions shown beneath the chip input.
 * The drawer surfaces the first {@link CLASSIFICATION_SUGGESTION_SLOTS} that
 * aren't already selected; when the user picks one, the next unused entry
 * from the pool slides in to keep the visible strip topped up.
 */
export const CLASSIFICATION_RULE_SUGGESTIONS: readonly string[] = [
  'Current address',
  'Date of birth',
  'Issuing authority',
  'Expiration date',
  'Issue date',
  'ID number',
  'Phone number',
  'Email address',
  'Restrictions',
  'Endorsements'
];

export const CLASSIFICATION_SUGGESTION_SLOTS = 3;
